import { BadgeOutlined, Info, UploadFile } from '@mui/icons-material';
import type { MenuButtonType } from '@/components/common/standard.modal';

export type MenuKey = 'general' | 'assignments' | 'mediaFiles' | 'crewRoles';

export const menuButtons: MenuButtonType<MenuKey>[] = [
  { icon: <Info />, key: 'general', translationKey: 'common.profile' },
  { icon: <UploadFile />, key: 'mediaFiles', translationKey: 'event.detail.addEditContributor.steps.mediaFiles.title' },
  {
    icon: <BadgeOutlined />,
    key: 'crewRoles',
    translationKey: 'event.detail.addEditContributor.steps.crewRoles.menuName',
  },
];
